'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(Jurisdiction2) {
  Jurisdiction2["MGA"] = "MGA";
  Jurisdiction2["SGA"] = "SGA";
  Jurisdiction2["UKGC"] = "UKGC";
  Jurisdiction2["IAUI"] = "IAUI";
  Jurisdiction2["LOTBA"] = "LOTBA";
  Jurisdiction2["ONJN"] = "ONJN";
  Jurisdiction2["AGCO"] = "AGCO";
  Jurisdiction2["EMTA"] = "EMTA";
})(exports.Jurisdiction || (exports.Jurisdiction = {}));
function isLOTBA(currentJurisdiction) {
  return currentJurisdiction === exports.Jurisdiction.LOTBA;
}
function isONJN(currentJurisdiction) {
  return currentJurisdiction === exports.Jurisdiction.ONJN;
}
function isAGCO(currentJurisdiction) {
  return currentJurisdiction === exports.Jurisdiction.AGCO;
}
function isSGA(currentJurisdiction) {
  return currentJurisdiction === exports.Jurisdiction.SGA;
}
function isUKGC(currentJurisdiction) {
  return currentJurisdiction === exports.Jurisdiction.UKGC;
}
function isEMTA(currentJurisdiction) {
  return currentJurisdiction === exports.Jurisdiction.EMTA;
}
const INITIAL_CASH_BALANCE_KEY = "magic:initial_cash_balance";
const SESSION_START_TIME_KEY = "magic:session_start_time";

exports.INITIAL_CASH_BALANCE_KEY = INITIAL_CASH_BALANCE_KEY;
exports.SESSION_START_TIME_KEY = SESSION_START_TIME_KEY;
exports.isAGCO = isAGCO;
exports.isEMTA = isEMTA;
exports.isLOTBA = isLOTBA;
exports.isONJN = isONJN;
exports.isSGA = isSGA;
exports.isUKGC = isUKGC;
